import { render } from "./PantryImageRoomHorizontalView.vue?vue&type=template&id=fce3d6b8&ts=true"
import script from "./PantryImageRoomHorizontalView.vue?vue&type=script&lang=ts"
export * from "./PantryImageRoomHorizontalView.vue?vue&type=script&lang=ts"

import "./PantryImageRoomHorizontalView.vue?vue&type=style&index=0&id=fce3d6b8&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__